import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AdventureProgram } from '../../models/adventure-program.model';
import { AdventureProgramService } from '../adventure-program.service';
import { ToastService } from 'angular-toastify';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdventureProgramStore {
  private _programs = new BehaviorSubject<AdventureProgram[] | null>(null);

  constructor(
    private adventureProgramService: AdventureProgramService,
    private toastService: ToastService
  ) {}

  get programs$(): Observable<AdventureProgram[] | null> {
    return this._programs.asObservable();
  }

  listPrograms(): Observable<AdventureProgram[]> {
    if (this._programs.value === null) {
      this.reloadPrograms();
    }
    return this._programs.asObservable().pipe(
      map(programs => programs || [])
    );
  }

  createProgram(program: Partial<AdventureProgram>): void {
    this.adventureProgramService.createProgram(program).subscribe({
      next: () => {
        this.toastService.success('Program created successfully');
        this.reloadPrograms();
      },
      error: () => {
        this.toastService.error('Failed to create program');
      }
    });
  }

  updateProgram(id: string, program: Partial<AdventureProgram>): void {
    this.adventureProgramService.updateProgram(id, program).subscribe({
      next: () => {
        this.toastService.success('Program updated successfully');
        this.reloadPrograms();
      },
      error: () => {
        this.toastService.error('Failed to update program');
      }
    });
  }

  deleteProgram(id: string): void {
    this.adventureProgramService.deleteProgram(id).subscribe({
      next: () => {
        this.toastService.success('Program deleted successfully');
        this.reloadPrograms();
      },
      error: () => {
        this.toastService.error('Failed to delete program');
      }
    });
  }

  private reloadPrograms(): void {
    this.adventureProgramService.listPrograms().subscribe({
      next: (programs) => {
        this._programs.next(programs);
      },
      error: () => {
        this.toastService.error('Failed to load programs');
        this._programs.next([]);
      }
    });
  }
}
